import { render } from "./TopItemsBySalesWidget.vue?vue&type=template&id=fa057686"
import script from "./TopItemsBySalesWidget.vue?vue&type=script&lang=js"
export * from "./TopItemsBySalesWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__